export default __webpack_public_path__ + "static/media/puppet.97e601a8.svg";